import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { Box, Typography, Stack, Button } from '@mui/material'
import { Oval } from 'react-loader-spinner'

import { postLogin } from 'service/TwoFactorService'

const ROLE_FALLBACK = {
  student: '/student-home/',
  teacher: '/teacher-home/',
  dean: '/dean-dashboard/',
  rectorate: '/admin/',
  sysadmin: '/admin/',
  methodist: '/admin/',
  hr_students: '/students-list/',
  hr_employees: '/employees/',
  accountant: '/accounting/',
  archivist: '/archive/',
  head_of_department: '/teacher-home/',
}

const RoleHomeRedirect = () => {
  const { t } = useTranslation('common')
  const navigate = useNavigate()
  const [error, setError] = useState('')

  useEffect(() => {
    let cancelled = false
    const go = async () => {
      try {
        const { data } = await postLogin()
        if (cancelled) return
        const target =
          data?.redirect_to ||
          ROLE_FALLBACK[data?.primary_role] ||
          '/home/'
        navigate(target, { replace: true })
      } catch (e) {
        if (cancelled) return
        const status = e?.response?.status
        if (status === 423) {
          navigate('/account-locked/', { replace: true })
          return
        }
        if (status === 401) {
          navigate('/', { replace: true })
          return
        }
        setError(e?.response?.data?.detail || t('auth.home_failed'))
      }
    }
    go()
    return () => {
      cancelled = true
    }
  }, [navigate, t])

  return (
    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '60vh' }}>
      <Stack spacing={2} alignItems="center">
        <Oval height={48} width={48} color="#FF7A00" secondaryColor="#ffe0c2" />
        <Typography color="text.secondary">{t('auth.redirecting')}</Typography>
        {error && (
          <>
            <Typography color="error">{error}</Typography>
            <Button onClick={() => navigate('/home/')} variant="contained" sx={{ bgcolor: '#FF7A00' }}>
              {t('auth.to_home')}
            </Button>
          </>
        )}
      </Stack>
    </Box>
  )
}

export default RoleHomeRedirect
